export default (props, vars) =>
  vars?.['applicationcard5']?.['item'].all_steps.findIndex(
    ({ stage }) =>
      stage === vars?.['applicationcard5']?.['item'].current_step.stage
  ) + 1;
